import styled from 'styled-components';

export const ShowSinglePageCanvas = styled.canvas`
  width: 100%;
  height: 100%;
  margin: 0px;
  overflow: hidden;
`;

export const MultiPagesCanvas = styled.canvas`
  display: block;
  height: 100%;
  margin: 8px auto;
`;
